/* Creamed theme — storefront behaviour (vanilla JS, no dependencies) */
(function () {
  'use strict';

  var root = document.documentElement;

  /* ---- Toast ------------------------------------------------------------- */
  var toastEl = document.getElementById('cart-toast');
  var toastText = document.getElementById('cart-toast-text');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastText.textContent = msg;
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, 2400);
  }

  /* ---- Cart count -------------------------------------------------------- */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  }
  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); })
      .catch(function () {});
  }

  /* ---- Cart drawer ------------------------------------------------------- */
  function openDrawer() { root.classList.add('drawer-open'); }
  function closeDrawer() { root.classList.remove('drawer-open'); }
  function renderDrawer(html) {
    var wrap = document.getElementById('shopify-section-cart-drawer');
    if (wrap && typeof html === 'string') { wrap.innerHTML = html; }
  }

  /* ---- Quick view -------------------------------------------------------- */
  var qvRoot = document.querySelector('[data-quick-view-root]');
  function openQV() { root.classList.add('qv-open'); if (qvRoot) qvRoot.hidden = false; }
  function closeQV() { root.classList.remove('qv-open'); if (qvRoot) { qvRoot.hidden = true; qvRoot.innerHTML = ''; } }

  /* ---- Add to cart (forms + quick-add) with Section Rendering ------------ */
  function addToCart(body, btn) {
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || 'Could not add to cart'); return; }
        toast((res.data.product_title || 'Item') + ' added to cart');
        if (res.data.sections && res.data.sections['cart-drawer']) {
          renderDrawer(res.data.sections['cart-drawer']);
        }
        refreshCartCount();
        closeQV();
        openDrawer();
      })
      .catch(function () { toast('Could not add to cart'); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to cart'; }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"], form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var body = { items: [{ id: fd.get('id'), quantity: parseInt(fd.get('quantity'), 10) || 1 }], sections: ['cart-drawer'] };
    addToCart(body, form.querySelector('[type="submit"]'));
  });

  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-add-variant]');
    if (!quick) return;
    e.preventDefault();
    addToCart({ items: [{ id: quick.getAttribute('data-add-variant'), quantity: 1 }], sections: ['cart-drawer'] }, quick);
  });

  /* ---- Cart mutations inside the drawer ---------------------------------- */
  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: ['cart-drawer'] })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.sections && cart.sections['cart-drawer']) renderDrawer(cart.sections['cart-drawer']);
        setCount(cart.item_count);
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle) { e.preventDefault(); openDrawer(); return; }

    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }

    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      var line = qtyBtn.closest('[data-line-key]');
      if (line) changeLine(line.getAttribute('data-line-key'), parseInt(qtyBtn.getAttribute('data-cart-qty'), 10));
      return;
    }

    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      var l = remove.closest('[data-line-key]');
      if (l) changeLine(l.getAttribute('data-line-key'), 0);
      return;
    }
  });

  /* ---- Quick view open --------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-view]');
    if (!trigger) return;
    e.preventDefault();
    var url = trigger.getAttribute('data-quick-view');
    if (!qvRoot) return;
    qvRoot.innerHTML = '<div class="qv qv--loading"><div class="qv__spinner"></div></div>';
    openQV();
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-view', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var content = tmp.querySelector('[data-quick-view-content]') || tmp;
        qvRoot.innerHTML = '';
        qvRoot.appendChild(content);
      })
      .catch(function () { closeQV(); toast('Could not load product'); });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-qv-close]')) { closeQV(); return; }
    if (e.target === qvRoot) closeQV();
  });

  /* ---- ESC closes overlays ---------------------------------------------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeQV(); }
  });

  /* ---- Quantity steppers (PDP / quick view) ------------------------------ */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.closest('.qty') && step.closest('.qty').querySelector('input');
    if (!input) return;
    var val = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10);
    if (val < 1) val = 1;
    input.value = val;
  });

  /* ---- Option pills -> hidden variant select ---------------------------- */
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-option-value]');
    if (!opt) return;
    var group = opt.closest('[data-option-group]');
    if (group) group.querySelectorAll('[data-option-value]').forEach(function (o) { o.classList.remove('is-active'); });
    opt.classList.add('is-active');
    var scope = opt.closest('[data-product-form-scope]') || document;
    var hidden = scope.querySelector('select[data-option-input="' + opt.getAttribute('data-option-name') + '"]');
    if (hidden) { hidden.value = opt.getAttribute('data-option-value'); hidden.dispatchEvent(new Event('change', { bubbles: true })); }
    updateVariant(scope);
  });

  /* ---- Resolve selected variant (price + id) ---------------------------- */
  function updateVariant(scope) {
    var form = scope.querySelector('form[data-ajax-cart], form[action$="/cart/add"]');
    var dataEl = scope.querySelector('[data-variant-json]');
    if (!form) return;
    var selects = scope.querySelectorAll('select[data-option-input]');
    if (!selects.length || !dataEl) return;
    var chosen = [];
    selects.forEach(function (s) { chosen.push(s.value); });
    var variants = JSON.parse(dataEl.textContent || '[]');
    var match = variants.find(function (v) { return v.options.join('~~') === chosen.join('~~'); });
    if (!match) return;
    var idInput = form.querySelector('[data-variant-id]');
    if (idInput) idInput.value = match.id;
    var priceEl = scope.querySelector('[data-price]');
    if (priceEl && window.Shopify) priceEl.textContent = formatMoney(match.price);
    var submit = form.querySelector('[type="submit"]');
    if (submit) { submit.disabled = !match.available; submit.textContent = match.available ? 'Add to cart' : 'Sold out'; }
  }
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---- Mobile menu ------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var nav = document.querySelector('[data-mobile-nav]');
    if (nav) nav.hidden = !nav.hidden;
  });

  /* ---- Gallery thumbnails ------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main] img');
    var src = thumb.getAttribute('data-full') || (thumb.querySelector('img') && thumb.querySelector('img').src);
    if (main && src) main.src = src;
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ---- Reveal on scroll -------------------------------------------------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }

  /* ---- Product recommendations ------------------------------------------ */
  function loadRecommendations() {
    document.querySelectorAll('[data-recommendations]').forEach(function (el) {
      if (el.dataset.loaded) return;
      var base = el.getAttribute('data-url');
      var id = el.getAttribute('data-product-id');
      var limit = el.getAttribute('data-limit') || 4;
      var intent = el.getAttribute('data-intent') || 'related';
      if (!base || !id) return;
      el.dataset.loaded = '1';
      var url = base + '?section_id=product-recommendations&product_id=' + id + '&limit=' + limit + '&intent=' + intent;
      fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim().length) {
            el.innerHTML = fresh.innerHTML;
            el.querySelectorAll('.reveal').forEach(function (r) { r.classList.add('in'); });
          }
        })
        .catch(function () {});
    });
  }
  loadRecommendations();

  /* ---- Order scheduling (date + time slot -> cart attributes) ----------- */
  function currentSchedule() {
    var d = document.querySelector('[data-order-date]');
    var s = document.querySelector('[data-order-slot]');
    return { date: d ? d.value : '', slot: s ? s.value : '' };
  }
  function saveSchedule() {
    var sc = currentSchedule();
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Order date': sc.date, 'Time slot': sc.slot } })
    }).catch(function () {});
  }
  document.addEventListener('change', function (e) {
    var d = e.target.closest('[data-order-date]');
    var s = e.target.closest('[data-order-slot]');
    if (!d && !s) return;
    if (d && d.value) {
      var dt = new Date(d.value + 'T00:00');
      if (dt.getDay() === 1) { toast("We're closed on Mondays — please pick another day."); d.value = ''; }
    }
    var note = document.querySelector('[data-sched-note]');
    if (note) note.hidden = true;
    saveSchedule();
  });
  document.addEventListener('click', function (e) {
    var co = e.target.closest('[data-checkout]');
    if (!co) return;
    var sc = currentSchedule();
    if (!sc.date || !sc.slot) {
      e.preventDefault();
      var note = document.querySelector('[data-sched-note]');
      if (note) note.hidden = false;
      toast('Please choose a date and time slot.');
    }
  });

  refreshCartCount();
})();
